function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import find from 'lodash/find';
import get from 'lodash/get';
import map from 'lodash/map';
import uniq from 'lodash/uniq';
import cn from 'classnames';
import { useAction } from 'hooks';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../../actions';
import * as selectors from '../../../selectors';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const getConnectAction = (selectedChannel)=>{
    // TODO: Update with new CGM
    if (selectedChannel === 'UsbC') return actions.connectUsbC;
    return actions.connectUsb;
};
const getInfoMessage = (selectedChannel)=>{
    switch(selectedChannel){
        case 'MicroUsb':
            return messages.connectUsbCable.info;
        case 'UsbC':
            return messages.connectUsbCCable.info;
        default:
            return messages.connectUsb.info;
    }
};
const renderImages = (selectedChannel)=>{
    switch(selectedChannel){
        case 'MicroUsb':
            {
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx("img", {
                            src: "/assets/svg/micro-usb.svg",
                            className: styles.connectionIcon,
                            alt: ""
                        }),
                        /*#__PURE__*/ _jsx("img", {
                            src: "/assets/svg/laptop.svg",
                            className: cn(styles.laptopIcon, 'mb-3'),
                            alt: ""
                        })
                    ]
                });
            }
        case 'UsbC':
            return /*#__PURE__*/ _jsx("img", {
                src: "/assets/svg/connect-by-usb-c-cable.svg",
                className: "w-100",
                alt: ""
            });
        default:
            return /*#__PURE__*/ _jsx("img", {
                src: "/assets/svg/connect-by-usb.svg",
                className: "w-100",
                alt: ""
            });
    }
};
const renderDeviceIcon = (caseType)=>/*#__PURE__*/ _jsx("li", {
        children: /*#__PURE__*/ _jsx("figure", {
            className: styles.devices__icon,
            dangerouslySetInnerHTML: {
                __html: caseType.icon
            }
        })
    }, caseType.caseTypeId);
const ConnectUsb = ({ selectedChannel, devicesByChannel, onSetComponent })=>{
    const connectionId = useSelector(selectors.connectionId);
    const caseTypes = useSelector(App.selectors.caseTypes);
    const microUsbDevices = get(devicesByChannel, 'MicroUsb', []);
    const caseTypeIds = uniq(map(microUsbDevices, (device)=>device.caseTypeId));
    const microUsbCaseTypes = map(caseTypeIds, (caseTypeId)=>find(caseTypes, {
            caseTypeId
        }));
    const infoMessage = getInfoMessage(selectedChannel);
    const startCheckingConnection = useAction(actions.startCheckingConnection);
    const connect = getConnectAction(selectedChannel);
    const onConnect = useAction(connect);
    useEffect(()=>{
        if (connectionId) {
            startCheckingConnection(connectionId);
            onSetComponent('Downloading');
        }
    }, [
        connectionId
    ]);
    const onChooseConnection = ()=>{
        onSetComponent('ChooseConnection');
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.howToStartConnection))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessage))
            }),
            /*#__PURE__*/ _jsx("ul", {
                className: styles.devices,
                children: map(microUsbCaseTypes, renderDeviceIcon)
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: renderImages(selectedChannel)
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.next,
                    className: "btn--block btn--filled mb-0",
                    onClick: onConnect
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.divider,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.divider__text,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.or))
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                labelMessage: messages.buttons.changeDeviceType,
                className: cn('btn--no-size text--primary m-0', styles.button__changeDevice),
                onClick: onChooseConnection
            })
        ]
    });
};
export default ConnectUsb;
